import { AccordionDetails, Typography } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


function PatientInfo(props) {

    let location = useLocation();
    const [expanded, setExpanded] = React.useState(false);
    const [childexpanded, setChildExpanded] = React.useState(false); 
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    const handleChildAccordianChange = (panel) => (event, isExpanded) => {
        setChildExpanded(isExpanded ? panel : false);
    };

    return (
        <div className="p-2  pt-20">
            <div className="text-xl font-semibold text-black py-2 flex mb-2 animate__animated animate__fadeInLeft " >
                <div className="inline-block self-center">Patient Information</div>
            </div>
            <div className="grid grid-cols-4 gap-2 ">
                <div className="col-span-1 p-3  border-sky-400  rounded border shdowsin shadow-inner animate__animated animate__fadeInLeft hv-box">
                    <div className={'mb-2 text-gray-600'}> Id : <span className={'mb-2  text-gray-800 font-semibold'}>89800087</span></div>
                    <div className={'mb-2 text-gray-600'}> Name : <span className={'mb-2 text-gray-800 font-semibold'}>{location.state.id}</span></div>
                    <div className={'mb-2 text-gray-600'}> Age : <span className={'mb-2 text-gray-800 font-semibold'}>29</span></div>
                    <div className={'mb-2 text-gray-600'}> Center : <span className={'mb-2 text-gray-800 font-semibold'}>Xyz Center, City</span></div>
                </div>
                <div className="col-span-3  p-3 pb-2 border-sky-400  rounded border shdowsin shadow-inner animate__animated animate__fadeInRight hv-box" >
                    <div className="mb-2 pb-2 border-b border-gray-300">
                        <div className="flex">
                            <div className="w-1/2 self-center font-semibold" style={{ col3or: "#1b2a47" }}>ML Analysis</div>
                        </div>
                    </div>
                    <div className={'mb-2 text-gray-600 mt-3'}> Title : <span className={'mb-2 text-black'}>89800087</span></div>
                    <div className={'mb-2 text-gray-600'}> Description :
                        <p className={'mb-2 text-black'}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                        </p>
                    </div>
                </div>
            </div>
            <div className={'grid grid-cols-2 gap-2 mt-4 mb-4 animate__animated animate__zoomIn'}>
                <div  >
                    <Accordion className="border border-green-400 drop-shadow-md" expanded={expanded === 'panel0'}
                        sx={{
                            marginBottom: "10px"
                        }}
                        onChange={handleChange('panel0')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel0bh-content" sx={{
                                backgroundColor: "#a9d3ac",
                            }}
                            id="panel0bh-header"
                        >
                            <div className="flex gap-2 ">
                                <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/illness.png')} />
                                <div className="inline-block self-center font-semibold">History of Patient illness</div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat.
                                Aliquam eget maximus est, id dignissim quam.
                            </Typography>
                            <Accordion className="bg-sky-200 border border-green-400 drop-shadow-md mt-2" sx={{
                                marginBottom: "10px"
                            }} expanded={childexpanded === 'panel1'} onChange={handleChildAccordianChange('panel1')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                    sx={{
                                        backgroundColor: "#a9d3ac",
                                    }}
                                >
                                    <div className="flex gap-2 ">
                                        <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/view.png')} />
                                        <div className="inline-block self-center font-semibold">First Visit</div>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Donec placerat, lectus sed mattis semper, neque lectus feugiat lectus,
                                        varius pulvinar diam eros in elit. Pellentesque convallis laoreet
                                        laoreet.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion className="bg-sky-200 border border-green-400 drop-shadow-md" sx={{
                                marginBottom: "10px"
                            }} expanded={childexpanded === 'panel2'} onChange={handleChildAccordianChange('panel2')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2bh-content"
                                    id="panel2bh-header"
                                    sx={{
                                        backgroundColor: "#a9d3ac",
                                    }}
                                >
                                    <div className="flex gap-2 ">
                                        <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/complaint.png')} />
                                        <div className="inline-block self-center font-semibold">Main Complaint</div>
                                    </div>
                                    <Typography sx={{ color: 'text.secondary' }}>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Donec placerat, lectus sed mattis semper, neque lectus feugiat lectus,
                                        varius pulvinar diam eros in elit. Pellentesque convallis laoreet
                                        laoreet.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion className="bg-sky-200 border border-green-400 drop-shadow-md" sx={{
                                marginBottom: "10px"
                            }} expanded={childexpanded === 'panel3'}
                                onChange={handleChildAccordianChange('panel3')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel3bh-content"
                                    id="panel3bh-header"
                                    sx={{
                                        backgroundColor: "#a9d3ac"
                                    }}
                                >
                                    <div className="flex gap-2 ">
                                        <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/pain-points.png')} />
                                        <div className="inline-block self-center font-semibold">How Patient got injured</div>
                                    </div>
                                    <Typography sx={{ color: 'text.secondary' }}>
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                        amet egestas eros, vitae egestas augue. Duis vel est augue.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="border border-green-400 drop-shadow-md" sx={{
                        marginBottom: "10px"
                    }} expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4bh-content"
                            id="panel4bh-header"
                            sx={{
                                backgroundColor: "#a9d3ac"
                            }}
                        >
                            <div className="flex gap-2 ">
                                <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/medical-history.png')} />
                                <div className="inline-block self-center font-semibold">Past Medical History</div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="border border-green-400 drop-shadow-md" sx={{
                        marginBottom: "10px"
                    }} expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel5bh-content"
                            id="panel5bh-header"
                            sx={{
                                backgroundColor: "#a9d3ac"
                            }}
                        >
                            <div className="flex gap-2 ">
                                <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/surgical.png')} />
                                <div className="inline-block self-center font-semibold">Past Surgical History</div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="border border-green-400 drop-shadow-md" sx={{
                        marginBottom: "10px"
                    }} expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel6bh-content"
                            id="panel6bh-header"
                            sx={{
                                backgroundColor: "#a9d3ac"
                            }}
                        >
                            <div className="flex gap-2 ">
                                <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/allergies.png')} />
                                <div className="inline-block self-center font-semibold">Allergies</div></div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="border border-green-400 drop-shadow-md" sx={{
                        marginBottom: "10px"
                    }} expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel7bh-content"
                            id="panel7bh-header"
                            sx={{
                                backgroundColor:"#a9d3ac"
                            }}
                        >
                            <div className="flex gap-2 ">
                                <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/medication.png')} />
                                <div className="inline-block self-center font-semibold">Medication</div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="border border-green-400 drop-shadow-md" sx={{
                        marginBottom: "10px"
                    }} expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel8bh-content"
                            id="panel8bh-header"
                            sx={{
                                backgroundColor: "#a9d3ac"
                            }}
                        >
                            <div className="flex gap-2 ">
                                <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/family.png')} />
                                <div className="inline-block self-center font-semibold">Family History</div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </div >
                <div>
                    <Accordion className="border border-green-400 drop-shadow-md" sx={{
                        marginBottom: "10px"
                    }} expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel9bh-content"
                            id="panel9bh-header"
                            sx={{
                                backgroundColor: "#a9d3ac"
                            }}
                        >
                            <div className="flex gap-2 ">
                                <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/people.png')} />
                                <div className="inline-block self-center font-semibold">Social History</div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="border border-green-400 drop-shadow-md" sx={{
                        marginBottom: "10px"
                    }} expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel10bh-content"
                            id="panel10bh-header"
                            sx={{
                                backgroundColor: "#a9d3ac"
                            }}
                        >
                            <div className="flex gap-2 ">
                                <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/pen.png')} />
                                <div className="inline-block self-center font-semibold">Review of Systems</div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="border border-green-400 drop-shadow-md" sx={{
                        marginBottom: "10px"
                    }} expanded={expanded === 'panel11'} onChange={handleChange('panel11')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel11bh-content"
                            id="panel11bh-header"
                            sx={{
                                backgroundColor: "#a9d3ac"
                            }}
                        >
                            <div className="flex gap-2 ">
                                <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/treatment.png')} />
                                <div className="inline-block self-center font-semibold">Physical Examination</div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="border border-green-400 drop-shadow-md"
                        sx={{
                            marginBottom: "10px"
                        }}
                        expanded={expanded === 'panel12'} onChange={handleChange('panel12')}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel12bh-content"
                            id="panel12bh-header"
                            sx={{
                                backgroundColor: "#a9d3ac"
                            }}
                        >
                            <div className="flex gap-2 ">
                                <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/telescope.png')} />
                                <div className="inline-block self-center font-semibold">Radiographs and Tests</div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="border border-green-400 drop-shadow-md" sx={{
                        marginBottom: "10px"
                    }} expanded={expanded === 'panel13'} onChange={handleChange('panel13')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel13bh-content"
                            id="panel13 bh-header"
                            sx={{
                                backgroundColor: "#a9d3ac"
                            }}
                        >
                            <div className="flex gap-2 ">
                                <img alt="Patient Details" className="bg-[#1b2a47] rounded-full p-1 w-8 " src={require('../../assets/icons/recovery.png')} />
                                <div className="inline-block self-center font-semibold">Impression Imlant</div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                                amet egestas eros, vitae egestas augue. Duis vel est augue.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </div >
        </div >
    )
}

export default PatientInfo;
